// src/App.js
import React, { useState, useEffect, useCallback } from 'react';
import { Heart, Image, BookOpen, User, Calendar, Scale, ChevronDown, ChevronUp, FileText, Menu, X, ChevronLeft, ChevronRight } from 'lucide-react';

const MemorialWebsite = () => {
  const [activeSection, setActiveSection] = useState('home');
  const [language, setLanguage] = useState('tr');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedMemorialCategory, setSelectedMemorialCategory] = useState(null);
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [expandedTestimonial, setExpandedTestimonial] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showHeader, setShowHeader] = useState(false);

  // Modal — index tabanlı navigasyon
  const [currentImageList, setCurrentImageList] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [touchStartX, setTouchStartX] = useState(null);

  const profileImage = './1st-photo.jpg';
  const slideImages = ['./slayt1.jpg', './slayt2.jpg', './slayt3.jpg'];

  // -------------------------------------------------------
  // Anılar — her obje: { id, name, text, date }
  // -------------------------------------------------------
  const memories = [
    {
      id: 1,
      name: 'Can Onal',
      text: `Gokcem,

Bu dunyada kendimi  sansli hissettigim zamanlar oldu. Ama sanirim en sansli oldugum noktalardan biri, senin gibi guzel ruhlu, altin kalpli, zeki, sevgi dolu bir insanla buyumek, cocuklugumu gecirmek, senin kuzenim(daha cok kardesim) olman. Cocuklugumuz, beni sekillendirisin, en guzel zamanlarimizi paylasmamiz. Sana tesekkur etmek istiyorum, butun kalbimle.

Seni ugurlamak kolay olmadi, hicbirimiz icin. Cok zordu Gokcem. Uzuntumuzu tarif etmek de oyle. Ama senin o guzel enerjin, bize, dogaya, bu dunyadaki zamaninda verdigin sevgi, hep bizimle. Burada, yanimizda. Sabaha kadar sohbetlerimiz, gulmelerimiz, okudugumuz kitaplar, izledigimiz filmler, Artur'da, Istanbul'da, Izmir'de, Milano'da, Paris'te, degisik sehirlerde, beraber gecirdigimiz sayisiz guzel an hep bizimle, hep yanimizda.Belki de zamanla bizi iyilestiricek sey de bu.Hikayelerimiz, anilarimiz ve hep hissettigimiz sonsuz sevgi.Tesekkurler Gokcem, paylastigimiz hersey icin, senin icin.Pinar ve benim ucuncu kardesimiz oldugun icin.

Sen yeryuzunde bir guzel ruhlu armagandin bize, simdi de ismin gibi gokyuzunde guzel ruhlu bir armagansin.Bizi o isil isil kalbinle, o guzel gulumsemenle izliyorsun.Seni cok seviyoruz, isiklar icinde uyu canim Gokcem, kuzenim, kardesim`,
      date: '23 Haziran 2025'
    },
    {
      id: 2,
      name: 'Kuzenin, Pınar Önal-Rieble',
      text: `Canım Gökçem,
Sen hiç gitmedin, hep bizimlesin. Aksini hiç düşünemiyorum.Kapımdan giren bir uğur böceğinde görüyorum seni, uçan kelebekte, sonra yeniden sen geliyorsun aklıma. Yanımızdan fiziksel olarak ayrıldığından beri bir yanım eksildi.Çünkü sen, Can ve ben beraber büyüdük. O kadar güzel anılar biriktirdik ki beraber, bir insanı hep mi güzel anarsın, hep mi onunla yaşadığın her an tadı damağında kalır, işte benim seninle ve Canla geçirdiğim her an böyle pahabiçilmezdi.

Ben üçümüzün beraber yaşlanıp bu hayata yine beraber gözlerimizi yumacağımız gibi planlar yaparken hayat beni ters köşeye yatırdı. Bir anda kız kardeşim gibi gördüğüm, canımdan çok sevdiğim kuzenimi elinden aldı hayat. Ama biliyorum sen benim güçlü olmamı isterdin, hayatta sitem etmek yerine ona sıkı sıkı tutunmamı öğütlerdin. Haklısın, o yüzden bu bir veda değil, tam tersi sana bu yazımda, seni her saniye bizimle yaşatmaya devam edeceğimizi anlatmaktı niyetim.

Benim canım kuzenim, bana yaşattığın o paha biçilemez her an için sana çok teşekkür ederim.

Seni çok seviyorum!

Sen hep bizimlesin!`,
      date: '25 Haziran 2025'
    },
    {
      id: 3,
      name: 'Annen',
      text: `Canım Kızım,
Bugün anneler günü...

Ve ben ilk kez senin gönderdiğin o güzel çiçekler olmadan, o küçük notlarını okumadan geçiriyorum bu günü.

Şimdi o notları tekrar tekrar okuyorum. Sanki sesin var içinde...

Sanki yine bana "Anne" diye sesleniyorsun.

Seni öyle özlüyorum ki...

Bu özlem dinmiyor, sadece derinleşiyor. Ama biliyorum, senin sevgin de benimle birlikte yaşıyor. Güzel kalbinle benim içimde yaşamaya devam ediyorsun.

Birlikte kurduğumuz hayaller vardı... Yapacağımız şeyler, gideceğimiz yerler ve paylaşacağımız nice an... Hepsi içimde bir yerde duruyor ancak sensiz... Yüreğinle düşünüp yapmak istediğin iyilikler artık benim görevim. Ben yaşadıkça, seni de o hayallerin içinde yaşatacağım. Bugün sana sarılamıyorum ama sen kalbimin en derin yerindesin. Değişmeyen, bitmeyen bir sevgiyle...

İyi ki benim kızımsın, iyi ki seni tanıdım, senin annen oldum. Seni çok seviyorum canımın içi....`,
      date: '26 Haziran 2025'
    }
  ];

  // -------------------------------------------------------
  // Anısına etkinlikleri
  // Fotoğraf dosyalarını public klasörüne ekleyip isimlerini buraya yazın
  // -------------------------------------------------------
  const eventsData = [
    {
      id: 'odtu-anma',
      title_tr: 'Gökçe Önal Yüksek Lisans Tez Ödül ve Anma Programı',
      title_en: "Gökçe Önal Master's Thesis Award and Memorial Program",
      subtitle_tr: 'ODTÜ Mimarlık Fakültesi Amfisi',
      subtitle_en: 'METU Faculty of Architecture Amphitheater',
      date: '20 Şubat 2026',
      coverImage: './left-photo.jpg',
      images: [
        './odtu-anma1.jpg',
        './odtu-anma2.jpg',
        './odtu-anma3.jpg',
        './odtu-anma4.jpg',
      ]
    },
    {
      id: 'anitkabir',
      title_tr: 'Anıtkabir Toplu Ziyareti',
      title_en: 'Group Visit to Anıtkabir',
      subtitle_tr: '',
      subtitle_en: '',
      date: '',
      coverImage: './anitkabir.jpg',
      images: [
        './anitkabir.jpg',
      ]
    },
  ];

  const translations = {
    tr: {
      nav: {
        home: 'Ana Sayfa',
        about: 'Hakkında',
        memorials: 'Projeler - Ödüller',
        gallery: 'Hatıralar',
        blog: 'Anılar',
        news: 'Basından Haberler',
        anisina: 'Anısına',
      },
      gallery: {
        title: 'Hatıralar',
        childhood: 'Çocukluk',
        youth: 'Gençlik',
        adulthood: 'Yetişkinlik',
        backToCategories: 'Kategorilere Dön'
      },
      memorials: {
        title: 'Projeler - Ödüller',
        projects: 'Projeler',
        awards: 'Ödüller',
        drawings: 'Karakalem Çalışmaları',
        backToCategories: 'Kategorilere Dön'
      },
      blog: {
        title: 'Anılar',
        noMemories: 'Henüz anı eklenmemiş.',
        readMore: 'Devamını Oku',
        readLess: 'Daha Az Göster'
      },
      anisina: {
        title: 'Anısına',
        subtitle: "Gökçe'nin anısına düzenlenen etkinlikler",
        backToEvents: '← Etkinliklere Dön',
        photoCount: 'fotoğraf',
      },
      copyright: {
        button: 'Telif Hakkı',
        title: 'Telif Hakkı Bildirimi',
        content: "Bu web sitesi üzerindeki tüm resim ve yazı içerikleri, Gökçe Önal ailesine aittir ve 5846 sayılı Fikir ve Sanat Eserleri Kanunu kapsamında korunmaktadır. Sitemizde yer alan metinler, görseller, videolar ve diğer tüm materyaller, izinsiz olarak kopyalanamaz, dağıtılamaz veya kullanılamaz. Web sitemizi ziyaret ettiğiniz için teşekkür ederiz. İçeriklerimize saygı göstermeniz, hem yasal haklarımızı korumamızı, hem de Gökçe Önal'a saygı gösterilmesini sağlayacaktır.",
        close: 'Kapat'
      },
      footer: 'Sevgiyle anıyoruz'
    },
    en: {
      nav: {
        home: 'Home',
        about: 'About',
        memorials: 'Projects - Awards',
        gallery: 'Memories',
        blog: 'Testimonials',
        news: 'Press News',
        anisina: 'In Her Memory',
      },
      gallery: {
        title: 'Memories',
        childhood: 'Childhood',
        youth: 'Youth',
        adulthood: 'Adulthood',
        backToCategories: 'Back to Categories'
      },
      memorials: {
        title: 'Projects - Awards',
        projects: 'Projects',
        awards: 'Awards',
        drawings: 'Charcoal Drawings',
        backToCategories: 'Back to Categories'
      },
      blog: {
        title: 'Testimonials',
        noMemories: 'No memories added yet.',
        readMore: 'Read More',
        readLess: 'Show Less'
      },
      anisina: {
        title: 'In Her Memory',
        subtitle: 'Events organized in memory of Gökçe',
        backToEvents: '← Back to Events',
        photoCount: 'photos',
      },
      copyright: {
        button: 'Copyright',
        title: 'Copyright Notice',
        content: 'All images and written content on this website belong to the family of Gökçe Önal and are protected under the Turkish Law No. 5846 on Intellectual and Artistic Works. All texts, images, videos, and other materials on this site cannot be copied, distributed, or used without permission. Thank you for visiting our website.',
        close: 'Close'
      },
      footer: 'Remembered with love'
    }
  };

  const t = translations[language];

  const galleryCategories = {
    childhood: {
      coverImage: './slayt1.jpg',
      images: [
        { src: './cocukluk1.jpg', caption: '' }, { src: './cocukluk2.jpg', caption: '' },
        { src: './cocukluk3.jpg', caption: '' }, { src: './cocukluk4.jpg', caption: '' },
        { src: './cocukluk5.jpg', caption: '' }, { src: './cocukluk6.jpg', caption: '' },
        { src: './cocukluk7.jpg', caption: '' }, { src: './cocukluk8.jpg', caption: '' },
        { src: './cocukluk9.jpg', caption: '' }, { src: './cocukluk10.jpg', caption: '' },
        { src: './cocukluk11.jpg', caption: '' }, { src: './cocukluk12.jpg', caption: '' }
      ]
    },
    youth: {
      coverImage: './slayt2.jpg',
      images: [
        { src: './genclik5.jpg', caption: { tr: 'Şubat 2014, ODTÜ', en: 'February 2014, METU' } },
        { src: './genclik2.jpg', caption: { tr: 'Şubat 2014, ODTÜ', en: 'February 2014, METU' } },
        { src: './genclik3.jpg', caption: { tr: 'Şubat 2014, ODTÜ', en: 'February 2014, METU' } },
        { src: './genclik4.jpg', caption: { tr: 'Şubat 2014, ODTÜ', en: 'February 2014, METU' } },
        { src: './genclik1.jpg', caption: '' },
        { src: './genclik6.jpg', caption: { tr: 'Şubat 2025, Rotterdam', en: 'February 2025, Rotterdam' } },
        { src: './genclik7.jpg', caption: '' }, { src: './genclik8.jpg', caption: '' },
        { src: './genclik9.jpg', caption: '' }
      ]
    },
    adulthood: {
      coverImage: './slayt3.jpg',
      images: [
        { src: './yetiskin1.jpg', caption: '' }, { src: './yetiskin2.jpg', caption: '' },
        { src: './yetiskin3.jpg', caption: { tr: 'İstanbul Maratonu, Kasım 2021', en: 'Istanbul Marathon, November 2021' } },
        { src: './yetiskin4.jpg', caption: { tr: 'Mısır, Mart 2023', en: 'Egypt, March 2023' } },
        { src: './yetiskin5.jpg', caption: { tr: 'Mısır, Mart 2023', en: 'Egypt, March 2023' } },
        { src: './music-1.jpg', caption: '' }, { src: './music-2.jpg', caption: '' },
        { src: './music-3.jpg', caption: '' },
      ]
    }
  };

  const memorialCategories = {
    projects: {
      coverImage: './panel-1.jpg',
      images: [
        { src: './proje-calisma(tahta).jpg' }, { src: './proje-sunum1.jpg' },
        { src: './proje-sunum2.jpg' }, { src: './panel-2.jpg' }
      ]
    },
    awards: {
      coverImage: './ataturk-award.jpg',
      images: [
        { src: './elemantary-award.jpg' }, { src: './gencmimar-award.jpg' },
        { src: './kocSchool-award.jpg' }, { src: './music-award.jpg' },
        { src: './raf.jpg' }, { src: './izocam.jpg' }, { src: './left-photo.jpg' }
      ]
    },
    drawings: {
      coverImage: './proje-calisma(resim).jpg',
      images: [
        { src: './karakalem1.jpg' }, { src: './karakalem2.jpg' }, { src: './karakalem3.jpg' },
        { src: './karakalem4.jpg' }, { src: './karakalem5.jpg' }, { src: './karakalem6.jpg' },
        { src: './karakalem7.jpg' }, { src: './karakalem8.jpg' }, { src: './karakalem9.jpg' },
        { src: './karakalem10.jpg' }, { src: './karakalem11.jpg' }, { src: './karakalem12.jpg' },
        { src: './karakalem13.jpg' }, { src: './karakalem14.jpg' }, { src: './karakalem15.jpg' },
        { src: './karakalem16.jpg' }
      ]
    }
  };

  const newsData = [
    {
      id: 1,
      title_tr: 'Mimar Gökçe Önal Vefat Etti',
      title_en: 'Architect Gökçe Önal has passed away.',
      imageUrl: './hakkinda.jpg',
      sourceUrl: 'https://www.arkitera.com/haber/mimar-gokce-onal-vefat-etti/'
    },
    {
      id: 2,
      title_tr: 'Genç Yaşta Hayatını Kaybeden Mimar Gökçe Önal Kimdir?',
      title_en: 'Who is Gökçe Önal, the Architect Who Passed Away at a Young Age?',
      imageUrl: './genclik7.jpg',
      sourceUrl: 'https://www.sonmuhur.com/genc-yasta-hayatini-kaybeden-mimar-gokce-onal-kimdir'
    },
    {
      id: 3,
      title_tr: 'Gökçe Önal Kimdir, Nereli, Kaç Yaşında, Öldü Mü, Akademik Kariyeri, Neden Öldü, Mimar Mıydı?',
      title_en: 'Who is Gökçe Önal, Where Is She From, How Old Is She, Is She Dead, What Is Her Academic Background, Why Did She Die, Was She an Architect?',
      imageUrl: './haber.png',
      sourceUrl: 'https://www.yenikiroba.com/gokce-onal-kimdir-nereli-kac-yasinda-oldu-mu-akademik-kariyeri-neden-oldu-mimar-miydi'
    }
  ];

  // -------------------------------------------------------
  // Modal helpers
  // -------------------------------------------------------
  const openImage = (list, index) => {
    setCurrentImageList(list);
    setSelectedImageIndex(index);
  };

  const closeImage = useCallback(() => {
    setSelectedImageIndex(null);
    setCurrentImageList([]);
  }, []);

  const navigateImage = useCallback((dir) => {
    setSelectedImageIndex(prev => {
      if (prev === null) return null;
      const next = prev + dir;
      if (next < 0) return currentImageList.length - 1;
      if (next >= currentImageList.length) return 0;
      return next;
    });
  }, [currentImageList.length]);

  // Klavye
  useEffect(() => {
    const onKey = (e) => {
      if (selectedImageIndex === null) return;
      if (e.key === 'ArrowRight') navigateImage(1);
      else if (e.key === 'ArrowLeft') navigateImage(-1);
      else if (e.key === 'Escape') closeImage();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [selectedImageIndex, navigateImage, closeImage]);

  // Swipe
  const handleTouchStart = (e) => setTouchStartX(e.touches[0].clientX);
  const handleTouchEnd = (e) => {
    if (touchStartX === null) return;
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) navigateImage(diff > 0 ? 1 : -1);
    setTouchStartX(null);
  };

  useEffect(() => {
    const si = setInterval(() => setCurrentSlide(p => (p + 1) % slideImages.length), 5000);
    const ht = setTimeout(() => setShowHeader(true), 1500);
    return () => { clearInterval(si); clearTimeout(ht); };
  }, [slideImages.length]);

  const truncateText = (text, maxLength = 200) => {
    if (!text || text.length <= maxLength) return text;
    const t = text.substring(0, maxLength);
    const i = t.lastIndexOf(' ');
    return (i > maxLength * 0.8 ? t.substring(0, i) : t) + '...';
  };

  const NavItem = ({ section, label }) => (
    <button onClick={() => setActiveSection(section)}
      className={`px-2 py-3 sm:px-4 sm:py-4 text-xs sm:text-base font-semibold transition-all duration-300 whitespace-nowrap ${activeSection === section ? 'bg-slate-600 text-white' : 'bg-white text-gray-700 hover:bg-slate-100'
        }`}>
      {label}
    </button>
  );

  const navItems = [
    { section: 'home', label: t.nav.home },
    { section: 'about', label: t.nav.about },
    { section: 'memorials', label: t.nav.memorials },
    { section: 'gallery', label: t.nav.gallery },
    { section: 'blog', label: t.nav.blog },
    { section: 'news', label: t.nav.news },
    { section: 'anisina', label: t.nav.anisina },
  ];

  const imgFallback = (e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; };
  const Placeholder = ({ size = 80 }) => (
    <div className="w-full h-full bg-gradient-to-br from-sky-100 via-slate-50 to-sky-50 flex items-center justify-center" style={{ display: 'none' }}>
      <Image size={size} className="text-slate-300" strokeWidth={1} />
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-200 via-blue-100 to-cyan-100 flex flex-col">

      {/* HEADER */}
      <header className={`bg-gradient-to-r from-slate-700 via-slate-600 to-slate-700 shadow-lg transition-all duration-1000 ${showHeader ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}`}>
        <nav className="max-w-7xl mx-auto relative">
          <div className="hidden md:block">
            <div className="absolute right-4 top-1/2 -translate-y-1/2 z-10">
              <button onClick={() => setLanguage(language === 'tr' ? 'en' : 'tr')}
                className="bg-white/20 hover:bg-white/30 text-white px-4 py-2 rounded-lg font-semibold transition-all text-sm">
                {language === 'tr' ? '🇬🇧 EN' : '🇹🇷 TR'}
              </button>
            </div>
            <div className="flex justify-center items-center divide-x divide-white/20 pr-32">
              {navItems.map(({ section, label }) => <NavItem key={section} section={section} label={label} />)}
            </div>
          </div>
          <div className="md:hidden">
            <div className="flex items-center justify-between px-4 py-3">
              <h1 className="text-white font-bold text-lg">Gökçe Önal</h1>
              <div className="flex items-center gap-2">
                <button onClick={() => setLanguage(language === 'tr' ? 'en' : 'tr')}
                  className="bg-white/20 hover:bg-white/30 text-white px-2 py-1 rounded text-sm">
                  {language === 'tr' ? 'EN' : 'TR'}
                </button>
                <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-white p-2">
                  {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
              </div>
            </div>
            {mobileMenuOpen && (
              <>
                <div className="fixed inset-0 bg-black/50 z-40" onClick={() => setMobileMenuOpen(false)} />
                <div className="absolute top-full left-0 w-full bg-slate-700 shadow-lg z-50">
                  <div className="flex flex-col">
                    {navItems.map(({ section, label }) => (
                      <button key={section} onClick={() => { setActiveSection(section); setMobileMenuOpen(false); }}
                        className={`px-4 py-3 text-left font-semibold border-b border-slate-600 ${activeSection === section ? 'bg-slate-600 text-white' : 'text-white hover:bg-slate-600'}`}>
                        {label}
                      </button>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </nav>
      </header>

      <main className="flex-1">

        {/* HOME */}
        {activeSection === 'home' && (
          <div className="animate-fadeIn">
            <div className="min-h-screen flex items-center justify-center py-8 px-4">
              <div className="text-center">
                <div className="w-64 h-64 rounded-full overflow-hidden border-8 border-white shadow-2xl mx-auto mb-8">
                  <img src={profileImage} alt="Gökçe Önal" className="w-full h-full object-cover" onError={imgFallback} />
                  <div className="w-full h-full bg-gradient-to-br from-sky-200 to-slate-200 items-center justify-center" style={{ display: 'none' }}>
                    <User size={100} className="text-slate-400" />
                  </div>
                </div>
                <h1 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">Gökçe Önal</h1>
                <p className="text-2xl md:text-3xl text-slate-600">(1988 - ∞)</p>
              </div>
            </div>
            <div className="py-16 px-8">
              <div className="max-w-5xl mx-auto">
                <div className="relative h-[450px] rounded-2xl overflow-hidden shadow-2xl">
                  {slideImages.map((img, i) => (
                    <div key={i} className={`absolute inset-0 transition-opacity duration-1000 ${i === currentSlide ? 'opacity-100' : 'opacity-0'}`}>
                      <img src={img} alt={`Slayt ${i + 1}`} className="w-full h-full object-cover" onError={imgFallback} />
                      <Placeholder size={120} />
                    </div>
                  ))}
                  <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-3 z-10">
                    {slideImages.map((_, i) => (
                      <button key={i} onClick={() => setCurrentSlide(i)}
                        className={`w-3 h-3 rounded-full transition-all ${i === currentSlide ? 'bg-white w-8' : 'bg-white/50 hover:bg-white/75'}`} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ABOUT */}
        {activeSection === 'about' && (
          <div className="animate-fadeIn py-20 px-8">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-5xl font-bold text-slate-800 text-center mb-16">{language === 'tr' ? 'Hakkında' : 'About'}</h2>
              <div className="bg-white border-2 border-slate-200 rounded-lg p-10 shadow-xl mb-8">
                <h3 className="text-3xl font-bold text-gray-800 mb-8">{language === 'tr' ? 'Gökçe Önal Kimdir?' : 'Who is Gökçe Önal?'}</h3>
                <div className="flex flex-col md:flex-row gap-8 mb-8">
                  <div className="md:w-1/3">
                    <div className="w-full aspect-[3/4] rounded-lg overflow-hidden border-4 border-slate-200 shadow-lg">
                      <img src="./hakkinda.jpg" alt="Gökçe Önal" className="w-full h-full object-cover" onError={imgFallback} />
                      <div className="w-full h-full bg-gradient-to-br from-sky-200 to-slate-200 flex items-center justify-center" style={{ display: 'none' }}>
                        <User size={80} className="text-slate-400" />
                      </div>
                    </div>
                  </div>
                  <div className="md:w-2/3 space-y-4 text-gray-700 leading-relaxed">
                    <p>
                      {language === 'tr' ? (
                        <><strong>Gökçe Önal</strong>, 2011 yılında <strong>İstanbul Teknik Üniversitesi Mimarlık Fakültesi'nden</strong> mezun oldu. Eğitime duyduğu tutku ve mesleki alana katkı sunma arzusu onu <strong>Orta Doğu Teknik Üniversitesi'ne (ODTÜ)</strong> taşıdı. ODTÜ Mimarlık Fakültesi'nde <strong>yüksek lisans</strong> yaparken aynı zamanda <strong>araştırma görevlisi</strong> olarak görev aldı. 2011 yılında düzenlenen 6. RAF Ürün Dergisi Kapak Tasarım Yarışması'na gönderdiği kapak tasarımı, 838 tasarım arasından seçilmiş, derginin 38. sayısının kapağında yer almıştır.</>
                      ) : (
                        <><strong>Gökçe Önal</strong> graduated from <strong>Istanbul Technical University Faculty of Architecture</strong> in 2011. Her passion for education led her to <strong>Middle East Technical University (METU)</strong>, where she pursued her <strong>master's degree</strong> and served as a <strong>research assistant</strong>. In 2011, her cover design for the 6th RAF Product Magazine Cover Design Competition was selected among 838 designs.</>
                      )}
                    </p>
                  </div>
                </div>
                <div className="space-y-6">
                  <div>
                    <h4 className="text-2xl font-bold text-gray-800 mb-4">{language === 'tr' ? 'Akademik Kariyer' : 'Academic Career'}</h4>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      {language === 'tr'
                        ? "Kariyerinin erken dönemlerinde kısa bir süre Ofis 16 Mimarlık çatısı altında mimari pratik deneyimi de yaşayan Gökçe, 2013 yılından sonra tamamen akademik çalışmalara yöneldi. 2016 yılından itibaren Hollanda'nın prestijli üniversitelerinden biri olan TU Delft Mimarlık ve Yapılı Çevre Fakültesi'nde çeşitli dönemlerde yarı zamanlı eğitmen olarak çalıştı."
                        : "After a brief period in architectural practice at Ofis 16 Architecture, Gökçe focused entirely on academic work from 2013. From 2016 onwards, she worked as a part-time instructor at TU Delft Faculty of Architecture and the Built Environment in the Netherlands."}
                    </p>
                    <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                      <li>{language === 'tr' ? 'Mimari tasarım stüdyoları yürüttü' : 'Led architectural design studios'}</li>
                      <li>{language === 'tr' ? 'Seçmeli dersler verdi' : 'Taught elective courses'}</li>
                      <li>{language === 'tr' ? 'Dijital ve çevrim içi eğitim içerikleri geliştirdi' : 'Developed digital and online educational content'}</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-gray-800 mb-4">{language === 'tr' ? 'Editörlük' : 'Editorial Activities'}</h4>
                    <p className="text-gray-700 leading-relaxed">
                      {language === 'tr'
                        ? "2021 yılından itibaren Backchannels 4S Blog'da yardımcı editör olarak görev aldı. Sosyal bilimler ve STS (Science, Technology and Society) içerik hazırlayan bu platformda disiplinler arası bakış açısını yaygınlaştırmayı hedefledi."
                        : "From 2021 onwards, she served as an assistant editor at Backchannels 4S Blog, a platform focused on social sciences and STS (Science, Technology and Society)."}
                    </p>
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-gray-800 mb-4">{language === 'tr' ? 'Kısa Bilgiler' : 'Quick Info'}</h4>
                    <div className="space-y-2 text-gray-700">
                      <p><strong>{language === 'tr' ? 'Mezuniyet:' : 'Graduation:'}</strong> {language === 'tr' ? 'İTÜ Mimarlık Fakültesi (2011)' : 'ITU Faculty of Architecture (2011)'}</p>
                      <p><strong>{language === 'tr' ? 'Yüksek Lisans & Görev:' : 'Master & Position:'}</strong> {language === 'tr' ? 'ODTÜ Mimarlık Fakültesi, araştırma görevlisi' : 'METU Faculty of Architecture, research assistant'}</p>
                      <p><strong>{language === 'tr' ? 'Uluslararası Kariyer:' : 'International Career:'}</strong> {language === 'tr' ? 'TU Delft, Hollanda – yarı zamanlı eğitmen' : 'TU Delft, the Netherlands – part-time instructor'}</p>
                      <p><strong>{language === 'tr' ? 'Editörlük:' : 'Editorial:'}</strong> {language === 'tr' ? 'Backchannels 4S Blog yardımcı editörü' : 'Assistant editor at Backchannels 4S Blog'}</p>
                    </div>
                  </div>
                  <div className="mt-8 pt-6 border-t-2 border-gray-200 flex items-center justify-between">
                    <h4 className="text-2xl font-bold text-gray-800">{language === 'tr' ? 'Özgeçmiş' : 'Curriculum Vitae'}</h4>
                    <a href="./gokce-onal-cv.pdf" download="Gokce-Onal-CV.pdf"
                      className="inline-flex items-center gap-2 bg-slate-600 hover:bg-slate-700 text-white px-4 py-2 rounded-lg font-semibold transition-all shadow-md">
                      <FileText size={16} />
                      {language === 'tr' ? 'CV İndir' : 'Download CV'}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* MEMORIALS */}
        {activeSection === 'memorials' && (
          <div className="animate-fadeIn py-20 px-8">
            <div className="max-w-7xl mx-auto">
              <h2 className="text-5xl font-bold text-slate-800 text-center mb-16">{t.memorials.title}</h2>
              {!selectedMemorialCategory ? (
                <div className="grid md:grid-cols-3 gap-8">
                  {['projects', 'awards', 'drawings'].map((cat) => (
                    <div key={cat} onClick={() => setSelectedMemorialCategory(cat)}
                      className="bg-white border-2 border-slate-200 rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 cursor-pointer">
                      <div className="aspect-video overflow-hidden">
                        <img src={memorialCategories[cat].coverImage} alt={t.memorials[cat]} className="w-full h-full object-cover" onError={imgFallback} />
                        <Placeholder size={100} />
                      </div>
                      <div className="p-6 text-center"><h3 className="text-2xl font-bold text-gray-800">{t.memorials[cat]}</h3></div>
                    </div>
                  ))}
                </div>
              ) : (
                <div>
                  <button onClick={() => setSelectedMemorialCategory(null)} className="mb-8 px-6 py-3 bg-slate-600 hover:bg-slate-700 text-white rounded-lg font-semibold transition-all shadow-lg">
                    ← {t.memorials.backToCategories}
                  </button>
                  <h3 className="text-3xl font-bold text-slate-800 text-center mb-12">{t.memorials[selectedMemorialCategory]}</h3>
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {memorialCategories[selectedMemorialCategory].images.map((item, i) => {
                      const list = memorialCategories[selectedMemorialCategory].images.map(x => x.src);
                      return (
                        <div key={i} onClick={() => openImage(list, i)}
                          className="aspect-square rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300 cursor-pointer">
                          <img src={item.src} alt={`${t.memorials[selectedMemorialCategory]} ${i + 1}`} className="w-full h-full object-cover" onError={imgFallback} />
                          <Placeholder />
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* GALLERY */}
        {activeSection === 'gallery' && (
          <div className="animate-fadeIn py-20 px-8">
            <div className="max-w-7xl mx-auto">
              <h2 className="text-5xl font-bold text-slate-800 text-center mb-16">{t.gallery.title}</h2>
              {!selectedCategory ? (
                <div className="grid md:grid-cols-3 gap-8">
                  {['childhood', 'youth', 'adulthood'].map((cat) => (
                    <div key={cat} onClick={() => setSelectedCategory(cat)}
                      className="bg-white border-2 border-slate-200 rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 cursor-pointer">
                      <div className="aspect-square overflow-hidden">
                        <img src={galleryCategories[cat].coverImage} alt={t.gallery[cat]} className="w-full h-full object-cover" onError={imgFallback} />
                        <Placeholder />
                      </div>
                      <div className="p-6 text-center"><h3 className="text-2xl font-semibold text-gray-800">{t.gallery[cat]}</h3></div>
                    </div>
                  ))}
                </div>
              ) : (
                <div>
                  <button onClick={() => setSelectedCategory(null)} className="mb-8 px-6 py-3 bg-slate-600 hover:bg-slate-700 text-white rounded-lg font-semibold transition-all shadow-lg">
                    ← {t.gallery.backToCategories}
                  </button>
                  <h3 className="text-3xl font-bold text-slate-800 text-center mb-12">{t.gallery[selectedCategory]}</h3>
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {galleryCategories[selectedCategory].images.map((item, i) => {
                      const list = galleryCategories[selectedCategory].images.map(x => x.src);
                      return (
                        <div key={i}>
                          <div onClick={() => openImage(list, i)}
                            className="aspect-square rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300 cursor-pointer">
                            <img src={item.src} alt={`${t.gallery[selectedCategory]} ${i + 1}`} className="w-full h-full object-cover" onError={imgFallback} />
                            <Placeholder />
                          </div>
                          {item.caption && item.caption[language] && (
                            <div className="mt-3 text-center">
                              <p className="text-gray-700 font-medium text-sm bg-white/80 rounded-lg py-2 px-4 inline-block shadow-sm">{item.caption[language]}</p>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* BLOG */}
        {activeSection === 'blog' && (
          <div className="animate-fadeIn py-20 px-8">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-5xl font-bold text-slate-800 mb-16">{t.blog.title}</h2>
              <div className="space-y-6">
                {memories.length === 0 && (
                  <div className="text-center py-16">
                    <BookOpen size={60} className="mx-auto mb-4 opacity-30 text-gray-400" />
                    <p className="text-xl text-gray-500">{t.blog.noMemories}</p>
                  </div>
                )}
                {memories.map((memory) => {
                  const isExpanded = expandedTestimonial === memory.id;
                  const shouldTruncate = memory.text.length > 200;
                  const displayText = isExpanded || !shouldTruncate ? memory.text : truncateText(memory.text, 200);
                  return (
                    <div key={memory.id} className="bg-white border-2 border-slate-200 rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                      <div className="flex justify-between items-start mb-6 pb-6 border-b-2 border-slate-200">
                        <div className="flex items-center gap-3">
                          <User size={24} className="text-sky-600" />
                          <span className="font-bold text-xl text-gray-800">{memory.name}</span>
                        </div>
                        <div className="flex items-center gap-2 text-gray-500">
                          <Calendar size={18} /><span>{memory.date}</span>
                        </div>
                      </div>
                      <p className="text-gray-700 leading-relaxed text-lg whitespace-pre-wrap mb-4 memory-text">{displayText}</p>
                      {shouldTruncate && (
                        <button onClick={() => setExpandedTestimonial(isExpanded ? null : memory.id)}
                          className="flex items-center gap-2 text-slate-600 hover:text-slate-800 font-semibold transition-colors">
                          {isExpanded ? <><ChevronUp size={20} />{t.blog.readLess}</> : <><ChevronDown size={20} />{t.blog.readMore}</>}
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {/* NEWS */}
        {activeSection === 'news' && (
          <div className="animate-fadeIn py-20 px-8">
            <div className="max-w-7xl mx-auto">
              <h2 className="text-5xl font-bold text-slate-800 text-center mb-16">{language === 'tr' ? 'Basından Haberler' : 'Press News'}</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {newsData.map((item) => (
                  <a key={item.id} href={item.sourceUrl} target="_blank" rel="noopener noreferrer"
                    className="group bg-white border-2 border-slate-200 rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300">
                    <div className="aspect-[4/3] overflow-hidden">
                      <img src={item.imageUrl} alt={language === 'tr' ? item.title_tr : item.title_en}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" onError={imgFallback} />
                      <Placeholder />
                    </div>
                    <div className="p-8">
                      <h3 className="text-xl font-bold text-gray-800 group-hover:text-slate-600 transition-colors mb-4">
                        {language === 'tr' ? item.title_tr : item.title_en}
                      </h3>
                      <p className="text-slate-600 font-medium">{language === 'tr' ? 'Haberi oku' : 'Read article'} →</p>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ANISINA */}
        {activeSection === 'anisina' && (
          <div className="animate-fadeIn py-20 px-8">
            <div className="max-w-7xl mx-auto">
              <h2 className="text-5xl font-bold text-slate-800 text-center mb-3">{t.anisina.title}</h2>
              <p className="text-center text-slate-500 mb-16 text-lg">{t.anisina.subtitle}</p>

              {!selectedEventId ? (
                <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                  {eventsData.map((event) => (
                    <div key={event.id} onClick={() => setSelectedEventId(event.id)}
                      className="bg-white border-2 border-slate-200 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 cursor-pointer">
                      <div className="aspect-video overflow-hidden relative">
                        <img src={event.coverImage} alt={language === 'tr' ? event.title_tr : event.title_en}
                          className="w-full h-full object-cover" onError={imgFallback} />
                        <Placeholder />

                      </div>
                      <div className="p-6">
                        <h3 className="text-xl font-bold text-gray-800 mb-1">{language === 'tr' ? event.title_tr : event.title_en}</h3>
                        {(language === 'tr' ? event.subtitle_tr : event.subtitle_en) && (
                          <p className="text-slate-500 text-sm mb-2">{language === 'tr' ? event.subtitle_tr : event.subtitle_en}</p>
                        )}
                        {event.date && (
                          <div className="flex items-center gap-2 text-slate-500 text-sm mt-3">
                            <Calendar size={15} /><span>{event.date}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (() => {
                const event = eventsData.find(e => e.id === selectedEventId);
                if (!event) return null;
                return (
                  <div>
                    <button onClick={() => setSelectedEventId(null)} className="mb-8 px-6 py-3 bg-slate-600 hover:bg-slate-700 text-white rounded-lg font-semibold transition-all shadow-lg">
                      {t.anisina.backToEvents}
                    </button>
                    <div className="text-center mb-12">
                      <h3 className="text-3xl font-bold text-slate-800 mb-2">{language === 'tr' ? event.title_tr : event.title_en}</h3>
                      {(language === 'tr' ? event.subtitle_tr : event.subtitle_en) && (
                        <p className="text-slate-500 text-lg">{language === 'tr' ? event.subtitle_tr : event.subtitle_en}</p>
                      )}
                      {event.date && (
                        <div className="flex items-center justify-center gap-2 text-slate-500 mt-2">
                          <Calendar size={16} /><span>{event.date}</span>
                        </div>
                      )}
                    </div>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                      {event.images.map((src, i) => (
                        <div key={i} onClick={() => openImage(event.images, i)}
                          className="aspect-square rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300 cursor-pointer">
                          <img src={src} alt={`${language === 'tr' ? event.title_tr : event.title_en} ${i + 1}`}
                            className="w-full h-full object-cover" onError={imgFallback} />
                          <Placeholder />
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        )}

      </main>

      {/* IMAGE MODAL — klavye (←→ Esc) + swipe */}
      {selectedImageIndex !== null && currentImageList.length > 0 && (
        <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center animate-fadeIn"
          onClick={closeImage} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
          <button onClick={closeImage}
            className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300 z-10 w-10 h-10 flex items-center justify-center">×</button>
          {currentImageList.length > 1 && (
            <div className="absolute top-4 left-1/2 -translate-x-1/2 text-white/60 text-sm z-10">
              {selectedImageIndex + 1} / {currentImageList.length}
            </div>
          )}
          {currentImageList.length > 1 && (
            <button onClick={(e) => { e.stopPropagation(); navigateImage(-1); }}
              className="absolute left-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white bg-white/10 hover:bg-white/25 rounded-full p-3 transition-all z-10">
              <ChevronLeft size={32} />
            </button>
          )}
          <img src={currentImageList[selectedImageIndex]} alt="Büyük görünüm"
            className="max-w-[85vw] max-h-[85vh] object-contain rounded-lg shadow-2xl"
            onClick={(e) => e.stopPropagation()} />
          {currentImageList.length > 1 && (
            <button onClick={(e) => { e.stopPropagation(); navigateImage(1); }}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white bg-white/10 hover:bg-white/25 rounded-full p-3 transition-all z-10">
              <ChevronRight size={32} />
            </button>
          )}
        </div>
      )}

      {/* COPYRIGHT MODAL */}
      {activeSection === 'copyright' && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 animate-fadeIn"
          onClick={() => setActiveSection('home')}>
          <div className="bg-white rounded-xl p-10 max-w-2xl w-full shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-center mb-6"><Scale size={48} className="text-slate-600" /></div>
            <h2 className="text-3xl font-bold text-slate-800 text-center mb-6">{t.copyright.title}</h2>
            <p className="text-gray-700 leading-relaxed">{t.copyright.content}</p>
            <button onClick={() => setActiveSection('home')}
              className="mt-8 w-full bg-slate-600 hover:bg-slate-700 text-white py-3 rounded-lg font-semibold transition-all">
              {t.copyright.close}
            </button>
          </div>
        </div>
      )}

      {/* FOOTER */}
      <footer className="bg-gradient-to-r from-slate-700 via-slate-600 to-slate-700 text-white py-8">
        <div className="max-w-7xl mx-auto px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-lg flex items-center gap-2">
              {t.footer} <Heart size={20} className="fill-white" />
            </p>
            <button onClick={() => setActiveSection('copyright')}
              className="flex items-center gap-2 px-6 py-2 bg-white/10 hover:bg-white/20 rounded-lg font-semibold transition-all border border-white/20">
              <Scale size={18} /> {t.copyright.button}
            </button>
          </div>
        </div>
      </footer>

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fadeIn { animation: fadeIn 0.5s ease-out; }
        header { position: sticky; top: 0; z-index: 40; }
        .memory-text { word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; hyphens: auto; max-width: 100%; }
      `}</style>
    </div>
  );
};

export default MemorialWebsite;